import { Component, Input, OnInit } from '@angular/core';
import { Path, TreeNode, TreeResource } from '@s8l/client-tree-lib';

import { CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';
import { CmsService } from 'src/app/services/cms.service';

@Component({
  selector: 'app-chat-activation-table',
  templateUrl: './chat-activation-table.component.html',
  styleUrls: ['./chat-activation-table.component.scss']
})
export class ChatActivationTableComponent implements OnInit {
  @Input() public root: TreeNode = new TreeNode({});

  public search = '';

  public showChildren: { [uuid: string]: boolean } = {};

  constructor(private cms: CmsService, private cmsServer: CmsServerService) {}

  ngOnInit(): void {}

  public matchesSearch(node: TreeNode) {
    if (this.search.length == 0) {
      return true;
    }

    return node.name.toLowerCase().includes(this.search.toLowerCase());
  }

  public prettyPath(node: TreeNode) {
    return Path.parse(node.path).removeFirst().get().join(' / ');
  }

  public trackByUUID(index: number, node: TreeNode) {
    return node.uuid;
  }

  public toggleNode(node: TreeNode) {
    if (typeof node.hasResource === 'function' && node.hasResource(TreeResource.Chat)) {
      return this.cmsServer.treeUpdateResource({
        chat: false,
        path: node.path,
        language: this.cms.language
      });
    } else {
      return this.cmsServer.treeUpdateResource({
        chat: true,
        path: node.path,
        language: this.cms.language
      });
    }
  }
}
